const getUniqueId = () => {
  return Date.now() + Math.floor(Math.random() * 1000000)
}

export default getUniqueId
